export const deepClone = <T>(arrayToClone: T[]): T[] => {
  if (!arrayToClone) return [];
  if (arrayToClone.length === 0) return [];

  const json = JSON.stringify(arrayToClone);

  return JSON.parse(json) as T[];
};
